var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RelationList',{attrs:{"relations":_vm.relationData,"is-loading":_vm.isLoadingMyRelationData,"is-last-page":!_vm.hasMoreMyRelations,"is-all-relations":false},on:{"loadMoreRelations":_vm.loadRelations}})}
var staticRenderFns = []

export { render, staticRenderFns }